export const resourceTypes = [
    {
        id: 1,
        text: 'Audio Pods',
        value: 'pod',
    },
    {
        id: 2,
        text: 'Community',
        value: 'community',
    },
    {
        id: 3,
        text: 'Science',
        value: 'science',
    },
];

export const resourceCategory = [
    {
        id: 1,
        text: 'Health',
        value: 'health',
    },
    {
        id: 2,
        text: 'Lifestyle',
        value: 'lifestyle',
    },
    {
        id: 3,
        text: 'Workplace',
        value: 'workplace',
    }
];

export const resourceFileTypes = [
    {
        id: 1,
        text: 'Audio',
        value: 'audio',
    },
    {
        id: 2,
        text: 'Article',
        value: 'article',
    },
    {
        id: 3,
        text: 'Calendar',
        value: 'calendar',
    },
    {
        id: 4,
        text: 'Pdf',
        value: 'pdf',
    },
    {
        id: 5,
        text: 'Video',
        value: 'video',
    }
];